import Vue from 'vue';
import warehouseTransformer from './../../transformers/warehouse';
import store from '../../store';

const success = ({ data }, resolve) => {
  const warehouse = warehouseTransformer.fetch(data);
  resolve(warehouse);
  store.dispatch('fetchCurrentWarehouse', warehouse);
};

const failed = () => {};

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`/warehouses/${id}`)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/warehouse/show.js